import type { EachAddButtonPosition, EachPresentation, FormEachNode } from '../types/layout';

const PRESENTATION_DEFAULTS: Record<EachPresentation, EachAddButtonPosition> = {
  inline: 'inline-end',
  'tag-row': 'inline-end',
  card: 'bottom-full-width',
  table: 'bottom-full-width',
  accordion: 'bottom-center',
  default: 'bottom-left',
};

export function resolveAddButtonPosition(node: FormEachNode): EachAddButtonPosition {
  return (
    node.addButton?.position
    ?? node.addPosition
    ?? PRESENTATION_DEFAULTS[node.presentation ?? 'default']
  );
}
